import React from "react";
import closeIcon from "@surgia/ui/icons/popup/close.svg";
import { useTranslation } from "react-i18next";
interface GenericModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  stepper?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  subtitle?: string;
  additionalTitleStyles?: string;
  additionalSubtitleStyles?: string;
  icon?: React.ReactNode;
  titleIcon?: React.ReactNode;
  additionalStyles?: string;
  additionalStylesMain?: string;
}

const GenericModal: React.FC<GenericModalProps> = ({
  title,
  open,
  onClose,
  stepper,
  footer,
  children,
  subtitle,
  additionalTitleStyles,
  additionalSubtitleStyles,
  icon,
  titleIcon,
  additionalStyles,
  additionalStylesMain,
}) => {
  if (!open) return null;
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm">
      <div
        className={`bg-white rounded-xl w-auto  h-auto shadow-xl p-6 relative max-w-[90vw] max-h-[90vh] overflow-auto ${additionalStyles}`}
      >
        {icon && icon}
        {/* Close Button */}
        <img
          src={closeIcon}
          alt="close"
          onClick={onClose}
          className={`absolute top-4 ${
            isRTL ? "left-4" : "right-4"
          } text-gray-400 hover:text-gray-600 text-2xl cursor-pointer`}
        />
        <div className="flex items-start justify-start gap-2">
          {" "}
          {titleIcon && titleIcon}
          <div>
            <h2
              className={`text-xl font-[500] mb-2 text-[#181D27] mb-0 ${additionalTitleStyles}`}
            >
              {title}
            </h2>
            <h3
              className={`text-sm text-gray-500 mb-2 text-[#535862] font-[300] ${additionalSubtitleStyles}`}
            >
              {subtitle}
            </h3>
          </div>
        </div>

        {/* Stepper */}
        {stepper && <div className="mb-4">{stepper}</div>}
        {/* Content */}
        <div className={`mb-4 ${additionalStylesMain}`}>{children}</div>
        {/* Footer */}
        {footer && (
          <div className="flex justify-end gap-2" dir="ltr">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default GenericModal;
